import * as React from 'react';
import styled from 'styled-components';

interface Props {
  coverHeight?: number;
  children?: any;
}

const Main = styled.main`
  background: #fff;
  padding: 1rem;
  > * {
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const Content = styled(Main)`
  margin-top: ${(props: Props) => (props.coverHeight ? props.coverHeight + 'px' : 'auto')};
`;

export default (props: Props) => {
  return <Content {...props}>{props.children}</Content>;
};



// WEBPACK FOOTER //
// ./src/components/Main/Main.tsx